import { addDays } from 'date-fns/addDays';
import { isPast } from 'date-fns/isPast';

import { getZonedDate } from '@eika-infrastruktur/date';

import { PaymentState } from '../../../../components/transaction/Payment/form/state';
import { SelectedReceiver } from '../../../../components/transaction/SelectedReceiver';
import type {
    AccountNumber,
    PaymentItemId,
    UpdatePaymentRequest,
    PaymentItemDetails as OutboxItemDetails,
} from '../../../../generated-types';
import nullableZonedDateToUtc from '../../../../utils/mapper/nullableZonedDateToUtc';

const getReceiver = (outboxPayment: OutboxItemDetails): SelectedReceiver => ({
    accountNumber: outboxPayment.receiver?.accountNumber ?? { value: '' },
    iban: outboxPayment.receiver?.iban,
    accountName: outboxPayment.receiver?.name,
});

export const getOutboxState = (outboxPayment: OutboxItemDetails, fromAccount: AccountNumber): PaymentState => {
    const paymentDate = isPast(addDays(new Date(outboxPayment.dueDate), 1))
        ? getZonedDate(new Date())
        : getZonedDate(outboxPayment.dueDate);

    return {
        toAccount: getReceiver(outboxPayment),
        fromAccount,
        paymentDate,
        note: outboxPayment.note ?? '',
        kid: outboxPayment.kid,
        amount: Math.abs(outboxPayment.amount),
        showFromAccounts: false,
        currency: outboxPayment.currency || 'NOK',
        acceptDuplicate: false,
        ownText: outboxPayment.ownText,
        receiptType: outboxPayment.receiptType,
    };
};

export const getOutboxMutateRequest = (
    outboxItem: OutboxItemDetails,
    state: PaymentState,
): { paymentId: PaymentItemId; request: UpdatePaymentRequest } => ({
    paymentId: outboxItem.paymentItemId,
    request: {
        currency: 'NOK',
        toAccount: state.toAccount?.accountNumber as AccountNumber,
        paymentDate: nullableZonedDateToUtc(state.paymentDate)!,
        ...(outboxItem.kid && { kid: { value: state.kid?.value ?? '' } }),
        ...(!outboxItem.kid && { text: state.note }),
        amount: state.amount as number,
        fromAccountNumber: state.fromAccount!,
        paymentType: 'PAYMENT',
        receiptType: state.receiptType,
        ownText: state.ownText,
    },
});
